// src/components/common/materials/OrderSummary.jsx
import React from "react";

export default function OrderSummary({ form }) {
  const { title, po_date, supplier, request_date, delivery_place, note, items = [], subtotal, vat_total, total } = form || {};

  return (
    <div className="space-y-2 text-sm">
      <div className="grid grid-cols-2 gap-2">
        <div className="text-gray-500">제목</div>
        <div className="font-medium">{title || "-"}</div>

        <div className="text-gray-500">발주일</div>
        <div>{po_date || "-"}</div>

        <div className="text-gray-500">공급업체</div>
        <div>{supplier || "-"}</div>

        <div className="text-gray-500">납기 요청일</div>
        <div>{request_date || "-"}</div>

        <div className="text-gray-500">납품 장소</div>
        <div>{delivery_place || "-"}</div>
      </div>

      {items.length > 0 && (
        <div className="mt-3">
          <div className="text-xs text-gray-500 mb-1">품목 ({items.length}건)</div>
          <div className="space-y-1">
            {items.slice(0, 3).map((item, i) => (
              <div key={i} className="flex justify-between text-xs bg-gray-50 px-2 py-1 rounded">
                <span>{item.name || item.code}</span>
                <span>{Number(item.qty).toLocaleString()} {item.unit}</span>
              </div>
            ))}
            {items.length > 3 && (
              <div className="text-xs text-gray-400">외 {items.length - 3}건...</div>
            )}
          </div>
        </div>
      )}

      <div className="border-t pt-2 mt-2 flex justify-between font-medium">
        <span>합계</span>
        <span>{Number(total || 0).toLocaleString()}원</span>
      </div>
    </div>
  );
}
